import React, {useMemo} from "react";
import {Tooltip} from "@mui/material";

const MediumSecondaryColor = ({themes, selectedThemeId, name}) => {
    const color = useMemo(() => (
        themes?.find(e => e.id === selectedThemeId)?.values?.find(e => e.colorName === name)?.value
    ), [themes, selectedThemeId, name])

    return (
        <>
            <Tooltip followCursor title={`Secondary Color ${color}`}>
                <div className={'theme-secondary-color'}>
                    <div style={{'--theme-secondary-color': color}}/>
                </div>
            </Tooltip>
        </>
    );
}

export default MediumSecondaryColor;
